import { createSearchParams, generatePath } from "react-router-dom-v5-compat";

import { createRoute } from "../common";

const route = createRoute({ createSearchParams, generatePath });

export { route };
